import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayersListingControls from './QualifiedPlayersListingControls';
import QualifiedPlayersListingFilters from './QualifiedPlayersListingFilters';
import { isFiltersDirty } from '../../listing/js/listing-helper';

export default class QualifiedPlayersListingHeader extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isFiltersVisible : true
        };
        this.onFiltersTogglerClick = this.onFiltersTogglerClick.bind(this);
    }

    onFiltersTogglerClick() {
        if (!isFiltersDirty(this.props.filters, this.props.options.filters)) {
            this.setState({ isFiltersVisible: !this.state.isFiltersVisible });
        }
    }

    render() {
        return (
            <div className="qualified-players-listing__header">
                <QualifiedPlayersListingControls
                    onFiltersChange={this.props.onFiltersChange}
                    filters={this.props.filters}
                    isFiltersApplied={this.props.isFiltersApplied}
                    options={this.props.options}
                    itemsCount={this.props.itemsCount}
                    onFiltersTogglerClick={this.onFiltersTogglerClick}
                    isFiltersVisible={this.state.isFiltersVisible}/>

                <QualifiedPlayersListingFilters
                    onFiltersChange={this.props.onFiltersChange}
                    filters={this.props.filters}
                    options={this.props.options}
                    isFiltersVisible={this.state.isFiltersVisible}/>
            </div>
        );
    }
}

QualifiedPlayersListingHeader.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    options: PropTypes.object.isRequired,
    isFiltersApplied: PropTypes.bool.isRequired,
    itemsCount: PropTypes.number.isRequired,
};
